import { getNodeServiceBaseUrl } from '../config/apiBase';

const BASE = () => `${getNodeServiceBaseUrl()}/api/quotes`;

const token = () => localStorage.getItem('zTaskAuthToken') || '';

const headers = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token()}`,
  'X-Client': 'web',
});

async function handle(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      data.message ||
      data.error?.message ||
      (typeof data.error === 'string' ? data.error : null) ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

const quoteService = {
  list: async () => handle(await fetch(`${BASE()}/`, { headers: headers() })),
  get: async (id) => handle(await fetch(`${BASE()}/${id}`, { headers: headers() })),
  create: async (body) =>
    handle(await fetch(`${BASE()}/`, { method: 'POST', headers: headers(), body: JSON.stringify(body) })),
  update: async (id, body) =>
    handle(await fetch(`${BASE()}/${id}`, { method: 'PATCH', headers: headers(), body: JSON.stringify(body) })),
  submit: async (id) =>
    handle(await fetch(`${BASE()}/${id}/submit`, { method: 'POST', headers: headers(), body: '{}' })),
  approve: async (id) =>
    handle(await fetch(`${BASE()}/${id}/approve`, { method: 'POST', headers: headers(), body: '{}' })),
  reject: async (id) =>
    handle(await fetch(`${BASE()}/${id}/reject`, { method: 'POST', headers: headers(), body: '{}' })),
  convertWo: async (id, body = {}) =>
    handle(
      await fetch(`${BASE()}/${id}/convert-wo`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(body),
      })
    ),
};

export default quoteService;
